// extracted by mini-css-extract-plugin
module.exports = {"sort_label":"b91d50d1"};